import React from "react";
import dayjs from "dayjs";

/**
 * Single chat bubble. Replaces the duplicated sent/received JSX blocks from
 * the original component — only alignment and color differ, so they're
 * driven by the `isOwnMessage` flag instead of being copy-pasted.
 */
function MessageBubble({ message, isOwnMessage }) {
  const time = message.timestamp?.toDate
    ? dayjs(message.timestamp.toDate()).format("hh:mm A")
    : "";

  return (
    <div className="w-full flex items-center justify-between">
      <div
        className={[
          "max-w-64 my-0.5 relative p-1 text-slate-800 border",
          isOwnMessage
            ? "bg-[#CDEBEA] rounded-l-lg rounded-br-lg ml-auto"
            : "bg-[#FFFFFF] rounded-r-lg rounded-bl-lg mr-auto",
        ].join(" ")}
      >
        {message.text}
        <div className="flex justify-end">
          <span className="text-[8px]">{time}</span>
        </div>
      </div>
    </div>
  );
}

export default React.memo(MessageBubble);